import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1231a1fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lead-passenger" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Lead Passenger")
], -1))
const _hoisted_3 = { class: "input-group" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col--12 col-sm--6" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col--12 col-sm--6" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col--12 col-sm--6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-wrapper" }, [
    /*#__PURE__*/_createElementVNode("p", null, "In the event of a change to your itinerary, Isles of Scilly Travel may contact you via phone or text. Mobile numbers will not be used for marketing purposes.")
  ])
], -1))
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col--12 col-sm--6 col-lg--3" }
const _hoisted_11 = { class: "col--12 col-sm--6 col-lg--3" }
const _hoisted_12 = { class: "col--12 col-sm--6 col-lg--3" }
const _hoisted_13 = { class: "col--12 col-sm--6 col-lg--3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseDropdown = _resolveComponent("BaseDropdown")!
  const _component_BaseInput = _resolveComponent("BaseInput")!
  const _component_BaseSection = _resolveComponent("BaseSection")!

  return (_openBlock(), _createBlock(_component_BaseSection, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_BaseDropdown, {
                name: 'passenger',
                label: 'Choose Passenger',
                placeholder: 'Choose Passenger',
                options: _ctx.passengers,
                hasError: _ctx.v$.leadPassenger.$error,
                errors: _ctx.v$.leadPassenger.$errors,
                valid: !_ctx.v$.leadPassenger.$invalid,
                modelValue: _ctx.v$.leadPassenger.$model,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.leadPassenger.$model) = $event))
              }, null, 8, ["options", "hasError", "errors", "valid", "modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_BaseInput, {
                type: 'text',
                name: 'number',
                label: 'Mobile Number',
                placeholder: 'Mobile Number',
                hasError: _ctx.v$.mobilePhone.$error,
                errors: _ctx.v$.mobilePhone.$errors,
                valid: !_ctx.v$.mobilePhone.$invalid,
                modelValue: _ctx.v$.mobilePhone.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.mobilePhone.$model) = $event))
              }, null, 8, ["hasError", "errors", "valid", "modelValue"])
            ]),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_BaseInput, {
                type: 'text',
                name: 'postcode',
                label: 'Postcode',
                placeholder: 'Postcode',
                hasError: _ctx.v$.postCode.$error,
                errors: _ctx.v$.postCode.$errors,
                valid: !_ctx.v$.postCode.$invalid,
                modelValue: _ctx.v$.postCode.$model,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.postCode.$model) = $event))
              }, null, 8, ["hasError", "errors", "valid", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_BaseInput, {
                type: 'text',
                name: 'city',
                label: 'City',
                placeholder: 'City',
                hasError: _ctx.v$.city.$error,
                errors: _ctx.v$.city.$errors,
                valid: !_ctx.v$.city.$invalid,
                modelValue: _ctx.v$.city.$model,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.city.$model) = $event))
              }, null, 8, ["hasError", "errors", "valid", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_BaseInput, {
                type: 'text',
                name: 'address',
                label: 'Address',
                placeholder: 'Address',
                hasError: _ctx.v$.address.$error,
                errors: _ctx.v$.address.$errors,
                valid: !_ctx.v$.address.$invalid,
                modelValue: _ctx.v$.address.$model,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.address.$model) = $event))
              }, null, 8, ["hasError", "errors", "valid", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_BaseDropdown, {
                name: 'country',
                label: 'Country',
                placeholder: 'Country',
                options: _ctx.countryList,
                hasError: _ctx.v$.countryCode.$error,
                errors: _ctx.v$.countryCode.$errors,
                valid: !_ctx.v$.countryCode.$invalid,
                modelValue: _ctx.v$.countryCode.$model,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v$.countryCode.$model) = $event))
              }, null, 8, ["options", "hasError", "errors", "valid", "modelValue"])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}